import dayjs from 'dayjs'

const formatAppDate = (date: string | Date) => {
  return dayjs(date).format('MM/DD/YYYY')
}

export default formatAppDate
